import { defineStore } from 'pinia';
import { services } from '@/assets/js/config.js';
import { useHttpStore } from './httpStore';

export const useCommonStore = defineStore('common', {
  state: () => ({
    loanTypes: [],
    allStatus: [],
    allBanks: [],
		caseStatuses: [],
		disbursementStatuses: [],
		collectionStatuses: [],
	}),
  getters: {
		getCaseStatuses() {
      this.caseStatuses = this.allStatus.filter(itm => itm.module == 'case');
			return this.caseStatuses;
    },
		getDisbursementStatuses() {
      this.disbursementStatuses = this.allStatus.filter(itm => itm.module == 'disbursement');
			return this.disbursementStatuses;
    },
		getCollectionStatuses() {
      this.collectionStatuses = this.allStatus.filter(itm => itm.module == 'collection');
			return this.collectionStatuses;
    }
  },
  actions: {
		initConstant(){
			//BANKS
			_gHlp.setLoading('fetch_loan_type')
			this.getLoanTypes().then(resp=>{
				_gHlp.removeLoading('fetch_loan_type')
			}).catch(err=>{
				_gHlp.removeLoading('fetch_loan_type')
			});

			this.getTables('banks').then(resp => {
				this.allBanks = resp.banks;
			});
			this.getAllStatus(true);
		},
		async getTables(tables) {
      const httpStore = useHttpStore();
      return new Promise(async (resolve, reject) => {
        const dbTables = [];
        const result = {};
        const tablesArr = tables.split(',');
        tablesArr.forEach(key => {
          const table = localStorage.getItem(`table.${key}`);
          if (!table) {
            dbTables.push(key);
          } else {
            result[key] = JSON.parse(table);
          }
        });
  
        if (dbTables.length > 0) {
          const resp = await httpStore.post(`${services.lookup}tables`, {tables: dbTables.join(',')});
          const data = resp.data.data;
          
          for (const key in data) {
            localStorage.setItem(`table.${key}`, JSON.stringify(data[key]));
            result[key] = data[key];
          }
        }
  
        resolve(result);
      });
    },

    getLoanTypes(refresh=false) {
			const httpStore = useHttpStore();
      const params = {paginate:'no_paginate'};
      return new Promise((resolve, reject) => {
				let localData = _gHlp.getLocalStorage('common.loanTypes')
				if(!_gHlp.isEmpty(localData) && !refresh) {
					this.loanTypes = localData;
					resolve(localData)
				}else{
					httpStore.get(`${services.invinity}loan-type`, params).then((resp) => {
						this.loanTypes = resp.data.data;
						_gHlp.setLocalStorage('common.loanTypes',this.loanTypes)
						resolve(this.loanTypes);
					}).catch(err => {
						_gNotif.errorFunction(err);
						reject(err)
					})
				}
      });
    },

    async getLoanType(id, refresh = false) {
      if (!this.loanTypes && refresh) {
				await this.getLoanTypes()
      }
			const loanType = (!_gHlp.isEmpty(this.loanTypes)) ? this.loanTypes.find(item => item.id === id) : null;
      return loanType;
    },

		updateLoanType(id, data) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.put(`${services.invinity}loan-type/${id}`, data).then((resp) => {
          resolve(resp.data);
        }).catch(err => {
					_gNotif.errorFunction(err);
					reject(err)
				})
      });
    },

    getDroplist(type) {
      const httpStore = useHttpStore();
      const params = { type };
      return new Promise((resolve, reject) => {
        httpStore.get(`${services.invinity}droplist`, params).then((resp) => {
          resolve(resp.data);
        }).catch(err => {
					_gNotif.errorFunction(err);
					reject(err)
				})
      });
    },

    createDroplist(droplist) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.post(`${services.invinity}droplist`, droplist).then((resp) => {
          resolve(resp.data);
        }).catch(err => {
					_gNotif.errorFunction(err);
					reject(err)
				})
      });
    },

    updateDroplist(id, droplist) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.put(`${services.invinity}droplist/${id}`, droplist).then((resp) => {
          resolve(resp.data);
        }).catch(err => {
					_gNotif.errorFunction(err);
					reject(err)
				})
      });
    },

    deleteDroplist(id) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.delete(`${services.invinity}droplist/${id}`).then((resp) => {
          resolve(resp.data);
        }).catch(err => {
					_gNotif.errorFunction(err);
					reject(err)
				})
      });
    },
    getAllStatus(refresh=false) {
			return new Promise((resolve, reject) => {
				const localData = _gHlp.getLocalStorage('common.allStatus');
				if(!_gHlp.isEmpty(localData) && !refresh){
					this.allStatus = localData;
					resolve(localData);
				}else{
					this.getStatusList({paginate:'no_paginate'}).then(res => {
						this.allStatus = res.data;
						_gHlp.setLocalStorage('common.allStatus',this.allStatus)
						resolve(this.allStatus);
					})
				}
			});	
    },
    getStatusList(params = {}) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.get(`${services.invinity}status`, params).then((resp) => {
          httpStore.convertPaginationKeys(resp.data);
          resolve(resp.data);
        }).catch(err => {
					_gNotif.errorFunction(err);
					reject(err)
				})
      });
    },

    createStatus(status) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.post(`${services.invinity}status`, status).then((resp) => {
          resolve(resp.data);
        }).catch(err => {
					_gNotif.errorFunction(err);
					reject(err)
				})
      });
    },

    updateStatus(id, status) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.put(`${services.invinity}status/${id}`, status).then((resp) => {
          resolve(resp.data);
        }).catch(err => {
					_gNotif.errorFunction(err);
					reject(err)
				})
      });
    },

    deleteStatus(id) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.delete(`${services.invinity}status/${id}`).then((resp) => {
          resolve(resp.data);
        }).catch(err => {
					_gNotif.errorFunction(err);
					reject(err)
				})
      });
    }
  }
})